const disable = btn => btn.setAttribute('disabled', 'disabled');
const enable = btn => btn.removeAttribute('disabled');
const setText = (btn, txt) => { btn.textContent = txt; };

export default (state, btn) => {
  if (state === 'disabled') {
    disable(btn);
    setText(btn, 'Een moment...');
  } else if (state === 'saved') {
    disable(btn);
    setText(btn, 'Opgeslagen');
  } else {
    enable(btn);
    setText(btn, 'Opslaan');
  }
};
